import React from 'react'
import { Modal, ModalBody, Button, Card, CardBody, CardText, CardTitle } from 'reactstrap'
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import getSystemFrontendSettings from './systemFrontendSettings'

class Popup extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isOpen: false,
            title: '',
            content: '',
            buttons: [],
        }
        this.toggle = this.toggle.bind(this)
        this.action = this.action.bind(this)
        this.checkNotifications = this.checkNotifications.bind(this)
    }

    action(type) {
        switch (type.toLowerCase()) {
            case 'close':
                this.setState({ isOpen: false })
                break
            default:
                this.setState({ isOpen: false })
                break
        }
    }

    toggle() {
        this.setState({ isOpen: !this.state.isOpen })
    }

    async checkNotifications() {
        try {
            const { notifications } = await getSystemFrontendSettings()
            if (notifications) {
                notifications.list.forEach(({ title, content, conditions, data }) => {
                    if (conditions && data) {
                        JSON.parse(conditions).list.forEach(({ type }) => {
                            if (this.props.history.action === "PUSH" && this.props.history.location.pathname === '/main' && this.props.history.location.state && this.props.history.location.state.notification && type === 'afterLoginOnce') {
                                this.setState({ isOpen: true, title, content, buttons: JSON.parse(data).buttons || [] })
                            }
                        })
                    }
                })
            }
        } catch(e) {
            console.error('notifications popup error', e)
        }
    }

    async componentWillReceiveProps() {
        await this.checkNotifications()
    }

    async componentWillMount() {
        await this.checkNotifications()
    }

    render() {
        return (
            <Modal isOpen={this.state.isOpen} toggle={this.toggle} className="tutorial-modal">
                <ModalBody>
                    <Card className='mb-0'>
                        <CardBody>
                            <CardTitle className="lg-font-size">{this.state.title}</CardTitle>
                            <CardText className="lg-font-size" dangerouslySetInnerHTML={{ __html: this.state.content }}></CardText>
                            <div className={`actions ${this.state.buttons.length > 1 ? "justify-content-between": "justify-content-end"}`}>
                                {
                                    this.state.buttons.map((button, index) => (
                                        <Button key={index} className="action-btn" onClick={() => this.action(button.action)}>
                                            <span className="text lg-font-size pl-0">{button.title}</span>
                                        </Button>
                                    ))
                                }
                            </div>
                        </CardBody>
                    </Card>
                </ModalBody>
            </Modal>
        )
    }
}

Popup.propTypes = {
    t: PropTypes.func,
    history: PropTypes.object,
}

export default withTranslation()(Popup)



// WEBPACK FOOTER //
// ./src/lib/Popup.jsx